import React from "react";
import NavbarCustom from "../Navbar";
import "./Header.css";
import Slider from "react-slick";

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  arrows: true,
  dots: true
};

class Header extends React.Component {
  render() {
    return (
      <Slider {...settings}>
        <div>
      <div className="header">
        <div class="row">
      <div class="container col-12 col-lg-6 col-sm-12 col-md-6 main">
        <h1 className="wl3">BAMBOO & LIME BRICKS COMPOSITE AFFORDABLE ECO-HOMES IN BAMBOO ECOLOGICAL CITIES</h1>
        <div style={{backgroundColor: 'green'}} className=" col-12">
        <p className="text-light x1 p-2">We are solving 25% of the world's chronic 'decent affordable housing' deficit with one solution - building eco-cities with disruptive innovative Bamboo, Lime, Laterite, Clay and Biochar composite construction technologies. Beginning with 25% of Ghana's 2.0 million chronic 'decent affordable housing' deficit.</p>
      </div>
      <div class="bContainer">
        <div className="buth">
        <button style={{backgroundColor:'green'}}  class="btn  text-light">Learn more about GMBAIS</button>
        </div>
        <div className="investButton">
        <button style={{backgroundColor:'green'}} class="btn  text-light ml-3">Invest</button>
        </div>
      </div>
      
     </div>
        </div>
      </div>
      </div>
      <div>
      <div class="header2">
      <div class="row">
      <div class="container col-12 col-lg-6 col-sm-12 col-md-6 main">
        <h1 className="wl3">BAMBOO & LIME BRICKS COMPOSITE AFFORDABLE ECO-HOMES IN BAMBOO ECOLOGICAL CITIES</h1>
        <div style={{backgroundColor: 'green'}} className=" col-12">
        <p  className="text-light x1 p-2">We are solving 25% of the world's chronic 'decent affordable housing' deficit with one solution - building eco-cities with disruptive innovative Bamboo, Lime, Laterite, Clay and Biochar composite construction technologies. Beginning with 25% of Ghana's 2.0 million chronic 'decent affordable housing' deficit.</p>
      </div>
      <div class="bContainer">
        <div className="buth">
        <button style={{backgroundColor:'green'}} class="btn  text-light">Learn more about GMBAIS</button>
        </div>
        <div className="investButton">
        <button style={{backgroundColor:'green'}} class="btn text-light ml-3">Invest</button>
        </div>
      </div>
      
     </div>
        </div>
      </div>
      </div>
      <div>
      <div class="header3">
      <div class="row">
      <div class="container col-12 col-lg-6 col-sm-12 col-md-6 main">
        <h1 className="wl3">BAMBOO & LIME BRICKS COMPOSITE AFFORDABLE ECO-HOMES IN BAMBOO ECOLOGICAL CITIES</h1>
        <div style={{backgroundColor: 'green'}} className=" col-12">
        <p  className="text-light x1 p-2">We are solving 25% of the world's chronic 'decent affordable housing' deficit with one solution - building eco-cities with disruptive innovative Bamboo, Lime, Laterite, Clay and Biochar composite construction technologies. Beginning with 25% of Ghana's 2.0 million chronic 'decent affordable housing' deficit.</p>
      </div>
      <div class="bContainer">
        <div className="buth">
        <button style={{backgroundColor:'green'}} class="btn  text-light">Learn more about GMBAIS</button>
        </div>
        <div className="investButton">
        <button style={{backgroundColor:'green'}} class="btn text-light ml-3">Invest</button>
        </div>
      </div>
      
     </div>
        </div>
      </div>
      </div>
      </Slider>
    )
  }
}
export default Header;
